export const WHATSAPP_URL = "https://wa.me/41786136096";

// TODO: replace with the official Google Business links of IMPERIUM when available.
// Review link format: https://g.page/r/<place-id>/review
export const GOOGLE_PROFILE_URL = "https://www.google.com/search?q=IMPERIUM+Beauty+%26+Wellness+Basel";
export const GOOGLE_REVIEW_URL = "https://www.google.com/search?q=IMPERIUM+Beauty+%26+Wellness+Basel+Bewertungen";
